module.exports = __webpack_public_path__ + "08_mole.6b307eae.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer2/08_mole.png
// module id = N858
// module chunks = 0